import { FC, useMemo, useState } from 'react';
import { Document, DocumentProps, Page } from 'react-pdf';

import './pdfViewer.scss';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
import 'react-pdf/dist/cjs/Page/TextLayer.css';

// Derived from react-pdf's public props rather than deep-imported from its dist folder: the
// package's `exports` map does not expose `dist/cjs/shared/types`, so exports-aware module
// resolution cannot see it.
type DocumentCallback = Parameters<NonNullable<DocumentProps['onLoadSuccess']>>[0];

type Props = {
  pdf: string;
};

export const PdfViewer: FC<Props> = ({ pdf }) => {
  const [totalPages, setTotalPages] = useState<number>(0);

  const onDocumentLoadSuccess = (doc: DocumentCallback) => {
    setTotalPages(doc.numPages);
  };

  const arrayPages = useMemo(() => {
    return Array.from({ length: totalPages }, (_, index) => index);
  }, [totalPages]);

  const renderPages = useMemo(() => {
    return arrayPages.map(value => {
      return (
        <div className={'pdf-page'} key={value}>
          <Page key={value} pageIndex={value} renderTextLayer={false} scale={1.2} />
        </div>
      );
    });
  }, [arrayPages]);

  return (
    <div className={'pdf-container'}>
      <Document
        className={'pdf-document'}
        file={pdf}
        key={pdf}
        onContextMenu={(e: MouseEvent | undefined) => e?.preventDefault()}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {renderPages}
      </Document>
    </div>
  );
};
